<template>
    <section id="blog-author" class="author-profile  away-top blog-author">
      <div class="inner" >
        <aside class="post-author">
          <figure class="post-author-avatar">
            <img src="../../../assets/images/ccx_2.jpeg" alt="Cheng,Changxin">
          </figure>
          <div id="infos">
            <span class="hidden">Changxin Cheng's Picture</span>
            <h1 class="author-title">Changxin Cheng</h1>
            <div class="author-meta">
              <span class="author-location icon-location">Beijing</span>
              <span class="author-link icon-link"><a href="http://changxin10m.com">https://changxin10m.com</a></span>
              <span class="author-stats"><i class="icon-stats"></i> {{ blogpostsnum }} posts</span>
            </div>
            <div class="author-search" v-if="showSearch">
              <search-bar
                v-model="localKeyword"
                :suggestions="suggestions"
                @search="emitSearch"
              ></search-bar>
            </div>
          </div>
        </aside>
      </div>
    </section>
</template>

<script>
import SearchBar from '../../../components/SearchBar'

export default {
  components: { SearchBar },
  name: 'author-info',
  props: {
    keyword: {
      type: String,
      default: ''
    },
    suggestions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      localKeyword: this.keyword
    }
  },
  computed: {
    blogpostsnum () {
      return this.$store.state.blogpostsum
    },
    showSearch () {
      return true
    }
  },
  watch: {
    keyword (newVal) {
      if (newVal !== this.localKeyword) {
        this.localKeyword = newVal || ''
      }
    }
  },
  methods: {
    emitSearch (value) {
      this.$emit('update:keyword', value)
      this.$emit('search', value)
    }
  }
}
</script>

<style scoped>
.inner,
  .pagination {
      width: auto;
      margin: 2rem auto;
  }
/*@import "../../../assets/css/screen.css";*/
/*@import "../../../assets/css/profile.css";*/

.author-meta {
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: 1.4rem;
    line-height: 1;
    font-style: italic;
    color: #9EABB3;
}

.author-meta a {
    color: #9EABB3;
}
.author-meta a:hover {
    color: #111;
}
#blog-author {
  position: relative;
}

#blog-author .post-author {
  position: relative;
  padding-top: 5rem;
  margin-top: 4rem;
  border-bottom: none;
  text-align: center;
}

#infos {
  margin-top: 4rem;
}

.author-title {
    margin: 1.5rem 0 1rem;
}

.author-bio {
    font-size: 1.8rem;
    line-height: 1.5em;
    font-weight: 200;
    color: #50585D;
    letter-spacing: 0;
    text-indent: 0;
}

.author-meta {
    margin: 1.6rem 0;
}

/* Location, website, and link */
.author-profile .author-meta {
    margin: 2rem 0;
    font-family: "Merriweather", serif;
    letter-spacing: 0.01rem;
    font-size: 1.7rem;
}
.author-meta span {
    display: inline-block;
    margin: 0 2rem 1rem 0;
    word-wrap: break-word;
}
.author-meta a {
    text-decoration: none;
}

/* Turn off meta for page2+ to make room for extra
   pagination prev/next links */
.paged .author-profile .author-meta {
    display: block;
}
.post-author-avatar{
  box-sizing: border-box;
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  width: 120px;
  height: 120px;
  margin: 0;
  transform: translate(-50%, -60%);
  border-radius: 100%;
  overflow: hidden;
  padding: 6px;
  background: #fff;
  z-index: 2;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

.post-author-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 100%;
}

.author-profile a:hover {
  color: #0b97c4;
}

.author-profile {
  padding: 0 15px 5rem 15px;
  border-bottom: none;
  text-align: center;
}

.author-search {
  margin-top: 3rem;
}
.author-search ::v-deep .search-bar {
  margin-top: 0;
}


/* Import the font file with the icons in it */
@font-face {
    font-family: "casper-icons";
    src:url("../../../assets/font/casper-icons.eot");
    src:url("../../../assets/font/casper-icons.eot") format("embedded-opentype"),
        url("../../../assets/font/casper-icons.woff") format("woff"),
        url("../../../assets/font/casper-icons.ttf") format("truetype"),
        url("../../../assets/font/casper-icons.svg") format("svg");
    font-weight: normal;
    font-style: normal;
}

/* Apply these base styles to all icons */
[class^="icon-"]:before, [class*=" icon-"]:before {
    font-family: "casper-icons", "Open Sans", sans-serif;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    text-decoration: none !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

/* Each icon is created by inserting the correct character into the
   content of the :before pseudo element. Like a boss. */
.icon-ghost:before {
    content: "\f600";
}
.icon-feed:before {
    content: "\f601";
}
.icon-twitter:before {
    content: "\f602";
    font-size: 1.1em;
}
.icon-google-plus:before {
    content: "\f603";
}
.icon-facebook:before {
    content: "\f604";
}
.icon-arrow-left:before {
    content: "\f605";
}
.icon-stats:before {
    content: "\f606";
}
.icon-location:before {
    content: "\f607";
    margin-left: -3px; /* Tracking fix */
}
.icon-link:before {
    content: "\f608";
}
.icon-menu:before {
    content: "\f609";
}
/*
    IMPORTANT: When making any changes to the icon font, be sure to increment
    the version number by 1 in the @font-face rule. `?v=1` becomes `?v=2`
    This forces browsers to download the new font file.
*/

</style>
